import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { HandleThreeDomainSecureRedirectRequest } from '@cash-web/shared-util-protos/squareup/franklin/rpc/handle_three_domain_secure_redirect.pb'
import { HandleThreeDomainSecureRedirectResponse } from '@cash-web/shared-util-protos/squareup/franklin/rpc/handle_three_domain_secure_redirect.pb'

export const handleThreeDomainSecureRedirect = (
  request: HandleThreeDomainSecureRedirectRequest,
  options?: CashRequestOptions
) =>
  post<HandleThreeDomainSecureRedirectRequest, HandleThreeDomainSecureRedirectResponse>(
    '/2.0/cash/handle-three-domain-secure-redirect',
    request,
    { ...options, rejectOnError: true }
  )
